import type { FsId } from '@fullstory/recording-api';
import type { NormalizedTagName } from '@fullstory/rewriters';
import { COMMENT_NODE_TAG } from '@fullstory/shared/node_decoder';
import type { FsDocument } from './fsdocument';
import { FsNode } from './fsnode';

/**
 * The vDOM representation of a {@link Comment} node.
 *
 * These are totally inert; they just exist to be present in the child list so
 * that MUT_INSERT can insert other nodes relative to them.
 *
 * TODO(sethf): Can we just get rid of these? The recording script doesn't
 * generate these anymore.
 */
export class FsComment extends FsNode {
  constructor(ownerDoc: FsDocument, fsid?: FsId) {
    super(ownerDoc, COMMENT_NODE_TAG as NormalizedTagName, undefined, fsid);
  }

  protected createNode(doc: Document): Comment {
    return doc.createComment('');
  }
}
